export enum PlanVersion {
  V1 = 1,
  V2 = 2, // Add Annual Plan
  V3 = 3, // Add Team Plan
}
export const latestPlanVersion = PlanVersion.V2;
